import React from 'react';
import '../../assets/css/bootstrap-grid.css';
import '../../assets/css/style.css';

const BannerEmpresaConvenio = () => {
  return (
    <div className="uninter-banner-convenioempresas">
      </div>
  );
}

export default BannerEmpresaConvenio;